;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';

function CandidateSearchIcon({ className = '' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="168.12" height="162.899" viewBox="0 0 168.12 162.899" className={className}>
      <g id="Icon_7" data-name="Icon 7" transform="translate(1.5 1.5)">
        <path
          id="Path_289"
          data-name="Path 289"
          d="M184.527,98.5V87.239c0-4.278-10.32-11.232-18.756-11.232S147,82.961,147,87.239V98.5"
          transform="translate(-83.203 17.846)"
          fill="rgba(0,0,0,0)"
          stroke="#222e50"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <circle
          id="Ellipse_9"
          data-name="Ellipse 9"
          cx="41"
          cy="41"
          r="41"
          transform="translate(41.326 49.4)"
          fill="rgba(0,0,0,0)"
          stroke="#ffb400"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Path_290"
          data-name="Path 290"
          d="M160.258,97.87c-6.77,0-11.258-5.73-11.258-12.8V80.8c0-7.07,4.488-12.8,11.258-12.8s11.258,5.73,11.258,12.8v4.271C171.516,92.139,167.028,97.87,160.258,97.87Z"
          transform="translate(-77.699 -4.201)"
          fill="rgba(0,0,0,0)"
          stroke="#222e50"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Path_291"
          data-name="Path 291"
          d="M176.527,70.239c0-4.278-10.32-11.232-18.756-11.232S139,65.961,139,70.239V81.5"
          transform="translate(-105.225 -28.951)"
          fill="rgba(0,0,0,0)"
          stroke="#222e50"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Path_292"
          data-name="Path 292"
          d="M152.258,80.87c-6.77,0-11.258-5.73-11.258-12.8V63.8c0-7.07,4.488-12.8,11.258-12.8s11.258,5.73,11.258,12.8v4.271C163.516,75.139,159.028,80.87,152.258,80.87Z"
          transform="translate(-99.721 -50.998)"
          fill="rgba(0,0,0,0)"
          stroke="#222e50"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Path_293"
          data-name="Path 293"
          d="M155,70.239c0-4.278,10.32-11.232,18.756-11.232s18.771,6.954,18.771,11.232V81.5"
          transform="translate(-61.182 -28.951)"
          fill="rgba(0,0,0,0)"
          stroke="#222e50"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Path_294"
          data-name="Path 294"
          d="M168.258,80.87c6.77,0,11.258-5.73,11.258-12.8V63.8c0-7.07-4.488-12.8-11.258-12.8S157,56.728,157,63.8v4.271C157,75.139,161.488,80.87,168.258,80.87Z"
          transform="translate(-55.676 -50.998)"
          fill="rgba(0,0,0,0)"
          stroke="#222e50"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Path_295"
          data-name="Path 295"
          d="M198.774,97.5V86.239c0-4.278-10.32-11.232-18.756-11.232-5.254,0-11.247,2.7-15.018,5.768"
          transform="translate(-33.654 15.092)"
          fill="rgba(0,0,0,0)"
          stroke="#222e50"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Path_296"
          data-name="Path 296"
          d="M177.258,96.87c-6.77,0-11.258-5.73-11.258-12.8V79.8c0-7.07,4.488-12.8,11.258-12.8s11.258,5.73,11.258,12.8v4.271C188.516,91.139,184.028,96.87,177.258,96.87Z"
          transform="translate(-30.902 -6.953)"
          fill="rgba(0,0,0,0)"
          stroke="#222e50"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Path_297"
          data-name="Path 297"
          d="M130,97.5V86.239c0-4.278,10.32-11.232,18.756-11.232,5.254,0,11.247,2.7,15.018,5.768"
          transform="translate(-130 15.092)"
          fill="rgba(0,0,0,0)"
          stroke="#222e50"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Path_298"
          data-name="Path 298"
          d="M143.258,96.87c6.766,0,11.258-5.73,11.258-12.8V79.8c0-7.07-4.488-12.8-11.258-12.8S132,72.728,132,79.8v4.271C132,91.139,136.488,96.87,143.258,96.87Z"
          transform="translate(-124.494 -6.953)"
          fill="rgba(0,0,0,0)"
          stroke="#222e50"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          id="Path_299"
          data-name="Path 299"
          d="M171.052,81l31.842,31.842a7.508,7.508,0,0,1,0,10.616l-2.653,2.653a7.5,7.5,0,0,1-10.613,0L157.782,94.266"
          transform="translate(-53.523 31.59)"
          fill="rgba(0,0,0,0)"
          stroke="#222e50"
          strokeLinejoin="round"
          strokeWidth="3"
        />
      </g>
    </svg>
  );
}

export default CandidateSearchIcon;
